/**
 * @file Custom form controls component (checkboxes and radio buttons).
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  type: PropTypes.oneOf(['radio', 'checkbox']).isRequired,
  size: PropTypes.oneOf(['xxl', 'xl', 'lg', 'md', 'sm', 'xs']),
  shape: PropTypes.oneOf(['round', 'squared']),
  id: PropTypes.string,
  labelSrOnly: PropTypes.bool,
  label: PropTypes.node,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  inputRef: PropTypes.func,
  showHint: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  wrap: PropTypes.bool,
  labelNote: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

const CustomControl = ({
  type,
  size = 'md',
  shape = 'round',
  id,
  label,
  labelSrOnly,
  labelNote,
  className,
  inputClassName,
  inputRef,
  showHint,
  children,
  wrap,
  ...props
}) => {
  const classes = classNames({
    'custom-control': true,
    'custom-control-xxl': size === 'xxl',
    'custom-control-xl': size === 'xl',
    'custom-control-lg': size === 'lg',
    'custom-control-sm': size === 'sm',
    'custom-control-xs': size === 'xs',
    'custom-checkbox': type === 'checkbox',
    'custom-radio': type === 'radio',
    'custom-control-sr-only': labelSrOnly,
    'custom-control-hinted': showHint,
    'custom-control-wrap': wrap,
    [`custom-control-${shape}`]: !!shape,
    [className]: className,
  });

  const inputClasses = classNames({
    'custom-control-input': true,
    [inputClassName]: !!inputClassName,
  });

  return (
    <Fragment>
      <label htmlFor={id} className={classes}>
        <input
          id={id}
          type={type}
          ref={inputRef}
          className={inputClasses}
          {...props}
        />
        <span className="custom-control-indicator" />
        <span className="custom-control-description">{label}</span>
        {labelNote && <span className="label-complement">{labelNote}</span>}
      </label>
      {children}
    </Fragment>
  );
};

CustomControl.propTypes = propTypes;

export default CustomControl;
